export const SIGN_UP_ERROR_IDS = {
    email: 'sign-up-email-error',
    emailTaken: 'sign-up-email-taken-error',
    title: 'sign-up-title-error',
    firstName: 'sign-up-first-name-error',
    firstNameMaxLength: 'sign-up-first-name-max-length-error',
    lastName: 'sign-up-last-name-error',
    lastNameMaxLength: 'sign-up-last-name-max-length-error',
    roomName: 'sign-up-room-name-error',
    roomNameTaken: 'sign-up-room-name-taken-error',
    password: 'sign-up-password-error',
    passwordHint: 'sign-up-password-tip',
    clinicName: 'sign-up-clinic-name-error',
    clinicDomain: 'sign-up-clinic-domain-error',
    clinicDomainTaken: 'sign-up-clinic-domain-taken-error',
    roomNameClinicTaken: 'sign-up-room-name-clinic-taken-error',
};
export const showSignUpFieldError = (hasContinueBeenClicked, fieldTouched, extra = true) => extra && (hasContinueBeenClicked || Boolean(fieldTouched));
export const joinDescribedBy = (...ids) => {
    const parts = ids.filter(Boolean);
    return parts.length > 0 ? parts.join(' ') : undefined;
};
export const fieldInvalidProps = (showError, ...describedByIds) => ({
    'aria-invalid': showError ? true : undefined,
    'aria-describedby': joinDescribedBy(...describedByIds),
});
